import { Component, Input, HostListener } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import type { MessageBoxOptions } from '../services/messageBox.service'

@Component({
  templateUrl: './messageBoxModal.component.pug',
})
export class MessageBoxModalComponent {
  @Input() options: MessageBoxOptions

  constructor (private modal: NgbActiveModal) { }

  @HostListener('document:keyup.enter', ['$event'])
  private onEnter (event) {
    event.preventDefault()
    event.stopPropagation()
    this.tryPositive()
  }

  @HostListener('document:keyup.space', ['$event'])
  private onSpace (event) {
    if (this.options.prompt) {
      return
    }
    event.preventDefault()
    event.stopPropagation()
    this.tryPositive()
  }

  @HostListener('document:keydown.escape', ['$event'])
  private onEscape (event: KeyboardEvent) {
    if (this.options.negative) {
      this.doNegative()
    }
    event.preventDefault()
    event.stopPropagation()
  }

  ngOnInit () {
    this.options.inputType ??= 'text'
  }

  tryPositive () {
    if (this.options.positive) {
      if (this.options.prompt && !this.options.value?.trim()) {
        return
      }
      this.doPositive()
    }
  }

  doPositive () {
    this.modal.close(this.options)
  }

  doNegative () {
    this.modal.dismiss()
  }
}
